import EditorDialog from "./EditorDialog";
import { categoryIconsMap } from "../../config/categoryIcons";

const colors = ["#F88225", "#6D28D9", "#16A34A", "#0EA5E9", "#EF4444", "#64748B"];

const IconPickerDialog = ({ open, onClose, icon, iconColor, onChange }) => (
  <EditorDialog open={open} onClose={onClose} title="ظاهر دسته‌بندی">
    <p className="mb-3 text-sm font-medium text-gray-700">آیکن</p>
    <div className="grid grid-cols-5 gap-2 sm:grid-cols-6">
      {Object.entries(categoryIconsMap).map(([key, Icon]) => (
        <button
          key={key}
          type="button"
          aria-label={`انتخاب آیکن ${key}`}
          aria-pressed={icon === key}
          onClick={() => onChange({ icon: key, iconColor })}
          className={`flex aspect-square items-center justify-center rounded-xl border text-xl ${icon === key ? "border-primary bg-primary/10" : "border-gray-200 hover:border-primary/50"}`}
        >
          <Icon style={{ color: iconColor }} />
        </button>
      ))}
    </div>
    <p className="mb-3 mt-6 text-sm font-medium text-gray-700">رنگ آیکن</p>
    <div className="flex flex-wrap gap-3">
      {colors.map((color) => (
        <button
          key={color}
          type="button"
          aria-label={`انتخاب رنگ ${color}`}
          aria-pressed={iconColor === color}
          onClick={() => onChange({ icon, iconColor: color })}
          className={`h-10 w-10 rounded-full border-2 ${iconColor === color ? "border-gray-900 ring-2 ring-gray-300" : "border-white"}`}
          style={{ backgroundColor: color }}
        />
      ))}
    </div>
    <button type="button" onClick={onClose} className="mt-6 min-h-11 w-full rounded-xl bg-secondary px-4 font-bold text-white">تمام</button>
  </EditorDialog>
);

export default IconPickerDialog;
